import React, { useState } from "react";
import { Heading } from "../../../design/heading";
import {
  DescriptionDetails,
  DescriptionList,
  DescriptionTerm,
} from "../../../design/description-list";
import { Button } from "../../../design/button";
import { Participant } from "../../../models/Participant";
import EducationForm from "../../../components/Forms/EducationForm";
import ParticipantTypeBadge from "../../../components/ParticipantTypeBadge";
import ParticipantRoleBadge from "../../../components/ParticipantRoleBadge";
import ParticipantSideBadge from "../../../components/ParticipantSideBadge";

interface ParticipantEducationProps {
  participant: Participant;
}

const ParticipantDetails: React.FC<ParticipantEducationProps> = ({
  participant,
}) => {
  return (
    <DescriptionList>
      {participant.names && (
        <>
          <DescriptionTerm>Names</DescriptionTerm>
          <DescriptionDetails>
            {participant.names.map((name, index) => (
              <span key={index}>
                {name}
                {index < participant.names.length - 1 && ", "}
              </span>
            ))}
          </DescriptionDetails>
        </>
      )}
      {participant.type && (
        <>
          <DescriptionTerm>Type</DescriptionTerm>
          <DescriptionDetails>
            <ParticipantTypeBadge type={participant.type} />
          </DescriptionDetails>
        </>
      )}
      {participant.role && (
        <>
          <DescriptionTerm>Role</DescriptionTerm>
          <DescriptionDetails>
            <ParticipantRoleBadge role={participant.role} />
          </DescriptionDetails>
        </>
      )}
      {participant.side && (
        <>
          <DescriptionTerm>Side</DescriptionTerm>
          <DescriptionDetails>
            <ParticipantSideBadge side={participant.side} />
          </DescriptionDetails>
        </>
      )}
      {participant.details && (
        <>
          <DescriptionTerm>Notes</DescriptionTerm>
          <DescriptionDetails style={{ whiteSpace: "pre-wrap" }}>
            {participant.details}
          </DescriptionDetails>
        </>
      )}
    </DescriptionList>
  );
};

export default ParticipantDetails;
